var render = function render(){var _vm=this,_c=_vm._self._c;return _c('md-card',{staticClass:"md-card-testimonial"},[_c('md-card-header',{staticClass:"icon"},[_c('md-icon',[_vm._t("header-icon")],2)],1),_vm._v(" "),_c('md-card-content',[_vm._t("content")],2),_vm._v(" "),_c('md-card-actions',{attrs:{"md-alignment":"left"}},[_vm._t("footer")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }